export const OFF = "@@power/OFF";
